// The order of object keys can't be changed
export const MAIN_NAVIGATION_ITEMS = {
  DASHBOARD: "dashboard",
  CANDIDATES: "candidates",
  AGENCIES: "agencies",
  BOOKINGS: "bookings",
  APPLICATIONS: "applications",
  INTERVIEWS: "interviews",
  CONVERSATIONS: "conversations",
  REPORTS: "reports",
  SETTINGS: "settings",
  JOBS: "jobs",
  OFFERS: "offers",
  EXPORTS: "exports"
};

export const SETTINGS_SECTIONS = {
  ACCOUNT: `settings/account`,
  ORGANISATION: `settings/organisation`
};
